import React from "react";
import { Heading, Img, Button, Text } from "../../components";

/**
 *  ריבוע יחיד בלוח "גישה מהירה"
 *
 *  props:
 *    count   – מספר להצגה
 *    label   – טקסט מתחת למספר
 *    bg      – צבע רקע (Hex / Tailwind)
 *    icon    – נתיב אייקון (URL או import)
 *    withStar – true => מציג כוכב קטן בפינה
 */
export default function QuickAccessTile({
  count = 0,
  label = "",
  onClick,
  bg = "",
  icon,
  withStar = false,
}) {
  return (
    <div onClick={onClick} className="small-template-ad relative w-full h-full flex flex-col items-center justify-center cursor-pointer">
      {/* כוכב קטן */}
      {withStar && (
        <Img src="/images/img_signal_red_a700_03.svg" alt="new" className="absolute h-[12px]" style={{ top: '8px', left: '31px' }} />
      )}

      {/* שורה עם מספר ואייקון */}
      <div className="flex flex-row items-center gap-1 mb-0.5 w-full justify-center"> 
        <Img src={icon} style={{ color: bg }} alt="" className="h-[24px]" />

        <Heading style={{ color: bg }} className="text-[30px] font-bold leading-none dashboard-desc2">
          {count}
        </Heading>
      </div>

      {/* תיאור */}
      <Text style={{ color: bg }} className="mt-0.5 text-[10px] font-medium leading-[12px] text-center dashboard-desc">
        {label}
      </Text>
    </div>
  );
}
